"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjectService = void 0;
const react_1 = require("react");
const ui_editor_data_access_projects_1 = require("@desygner/ui-editor-data-access-projects");
const react_rxjs_1 = require("@ngneat/react-rxjs");
/**
 * Usage
 *
 * const { project } = useProjectService();
 */
function useProjectService() {
    const [facade] = (0, ui_editor_data_access_projects_1.useProjectHook)(ui_editor_data_access_projects_1.ProjectDataFacade);
    const [project] = (0, react_rxjs_1.useObservable)(facade.project$, {
        initialValue: null,
    });
    (0, react_1.useEffect)(() => {
        facade.fetchCampaigns();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { project, facade };
}
exports.useProjectService = useProjectService;
//# sourceMappingURL=useProjectService.js.map